import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSeedling } from '@fortawesome/free-solid-svg-icons';

import omGanGanpatayeNamah from '../../assets/sounds/omGanGanpatayeNamah.mp4';
import omNamahShivay from '../../assets/sounds/omNamahShivay.mp4';
import sriRam from '../../assets/sounds/sriRam.mp4';

import ganeshji from '../../assets/pageimages/ganeshji.webp';
import shivji from '../../assets/pageimages/shivji.webp';
import sriramji from '../../assets/pageimages/sriram.webp';

import './Chanting.css';

import sanatanAd from '../../assets/pageimages/sanatanAd.webp';

const ChantingStart = () => {
  const navigate = useNavigate();
  const [repetitions, setRepetitions] = useState(10);
  const [currentCount, setCurrentCount] = useState(1);
  const [remainingCount, setRemainingCount] = useState(repetitions);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audio] = useState(new Audio(omNamahShivay));
  const [chantingStopped, setChantingStopped] = useState(false);
  const [isAudioEnded, setIsAudioEnded] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageArray, setImageArray] = useState([ganeshji, shivji, sriramji]);
  const imageTextArray = ["ॐ गं गणपतये नमः", "ॐ नमः शिवाय", "जय श्री राम"];
  const buttonTextArray = ["ॐ", "हर हर महादेव", "श्री राम"];
  const chantArray = [omGanGanpatayeNamah, omNamahShivay, sriRam];

  useEffect(() => {
    setSelectedImage(imageArray[0]); 
  }, []); 

  useEffect(() => {
    const handleEnded = () => {
      setTimeout(() => {
        setIsAudioEnded(true);
      }, 2000);
    };

    audio.addEventListener('ended', handleEnded);

    return () => {
      audio.removeEventListener('ended', handleEnded);
    };
  }, [audio]);

  useEffect(() => {
    if (isAudioEnded) {
      audio.pause();
    }
  }, [isAudioEnded]);

  const handleStart = () => {
    setIsPlaying(true);
    setCurrentCount(1);
    audio.loop = true;
    audio.play();
  };

  const handlePause = () => {
    setIsPlaying(false);
    audio.pause();
  };

  const handleStop = () => {
    setIsPlaying(false);
    setChantingStopped(true);
    audio.pause();
    audio.currentTime = 0;
  };

  const handleBackToHome = () => {
    navigate('/sanatan-home');
  };

  return (
    <div className='min-h-[100vh] bg-indigo-800'>
      <div className='border-b border-orange-600 text-white mb-4'>
        <h2 className='text-lg lg:text-xl mt-1 mx-8 text-yellow-200 mb-4'>Bhakti Chants</h2>
      </div>
      <div className="p-4 border-4 border-orange-400 mt-4">
        <div className="image-container">
          <div className="image-grid grid grid-cols-3 gap-4">
          {imageArray.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Image ${index}`}
                className="w-24 lg:w-80 cursor-pointer"
                onClick={() => setSelectedImage(image)}
              />
            ))}
          </div>
        </div>
        
        <div className="selected-image-container mt-4 place-items-center">
          {selectedImage && <img src={selectedImage} alt="Selected Image" className="w-40 lg:w-80" />}
        </div>
        <h2 className="text-4xl font-bold mt-4 text-red-500">{selectedImage && `${imageTextArray[imageArray.indexOf(selectedImage)]}`}</h2>
        <div className="timer text-white mt-4">
          Chant: {repetitions}
          <FontAwesomeIcon className="text-red-500" icon={faSeedling}></FontAwesomeIcon>
          Counted: {currentCount}{' '}
          <FontAwesomeIcon className="text-red-500" icon={faSeedling}></FontAwesomeIcon>
          Remaining: {remainingCount}
        </div>
        <div className="buttons mt-4">
          <button onClick={handleStart} disabled={isPlaying || repetitions === 0}>
            Start
          </button>
          <button onClick={handlePause} disabled={!isPlaying || repetitions === 0}>
            {' '}
            Pause
          </button>
          <button onClick={handleStop} disabled={!isPlaying || repetitions === 0}>
            Stop
          </button>
        </div>
        <div className="selected-image-container mt-4 place-items-center">
            <img src={sanatanAd} className="w-80 lg:w-full"  />
        </div>
        {chantingStopped && (
          <div className="additional-buttons">
          {selectedImage && (
            <button
              id="closebutton"
              className="bg-green-700"
              onClick={handleBackToHome}
            >
              {buttonTextArray[imageArray.indexOf(selectedImage)]}
            </button>
          )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChantingStart;
